import { IPublicClientApplication } from '@azure/msal-browser';
import { clearAuthorityFromStorage } from './AuthorityStorage';
import { clearEmailFromStorage } from './EmailStorage';

/**
 * Standardized logout function that ensures consistent cleanup across the application
 * @param instance - MSAL instance to perform the logout
 * @param postLogoutRedirectUri - Optional URI to redirect to after logout (defaults to '/sign-in')
 */
export function performLogout(
  instance: IPublicClientApplication,
  postLogoutRedirectUri = '/sign-in'
): void {
  // Clear all stored authentication data
  clearAuthorityFromStorage();
  clearEmailFromStorage();

  // Clear authentication data and perform logout

  // Perform the actual logout
  instance.logoutRedirect({
    postLogoutRedirectUri,
  });
}

/**
 * Logs out the user due to missing authentication requirements
 * @param instance - MSAL instance to perform the logout
 * @param reason - Reason for the logout (for logging purposes)
 */
export function performErrorLogout(
  instance: IPublicClientApplication,
  reason: string
): void {
  // eslint-disable-next-line no-console
  console.error('[Auth] Logout triggered:', reason);
  performLogout(instance, '/sign-in');
}
